import clsx from "clsx";
import { HomeIcon } from "lucide-react";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { actions } from "../../redux/slice";
import { useBoardsActions } from "../useBoardsActions";

interface HomeProps {
  selectedBoardId: string | null;
}

const Home: React.FC<HomeProps> = ({ selectedBoardId }) => {
  const params = useParams();
  const { project, team } = params;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { toggleBoardSetting } = useBoardsActions(params.project as string);

  const handleNavigate = () => {
    toggleBoardSetting(true);

    dispatch(actions.resetSelectedTickets());
    navigate(`/app/${project}/${team}/boards`);
  };
  return (
    <div>
      <div
        onClick={handleNavigate}
        className={clsx(
          "w-full h-full cursor-pointer bg-white relative flex flex-row items-center gap-2 px-4 uppercase text-sm font-normal text-secondary leading-5 py-2 hover:bg-gray-100 group flex-shrink-0",
          {
            "border-b-2 border-primary": !selectedBoardId,
          },
        )}
      >
        <HomeIcon size={20} color={!selectedBoardId ? "#5A8DF1" : "#79808A"} />
        <span
          className={clsx("whitespace-nowrap", {
            "text-primary font-semibold": !selectedBoardId,
          })}
        >
          Home
        </span>
      </div>
    </div>
  );
};

export default Home;
